export const KANA_REGEX = /^[ァ-・ヽヾ゛゜ー]+$/g
export const POSTAL_NUMBER_REGEX = /^\d{3}\d{4}$/
export const EMAIL_REGEX = /^[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,6}$/gm
export const PHONE_REGEX = /^0\d{9,10}$/
export const PASSWORD_REGEX = /^(?=.*[0-9])(?=.*[a-zA-Z])(.+){8,100}$/
export const OTP_REGEX = /^\d{6}$/
// Explicit Extended_Pictographic ranges from Unicode's emoji-data.txt, mirrored
// byte-for-byte in EMOJI_PATTERN in sheepmedical-api's RegisterUserInfo.php —
// PCRE (the API's regex engine) has no \p{Extended_Pictographic} support, so
// both sides use the same hardcoded codepoint list instead of each relying on
// its own engine's Unicode property (which could otherwise drift out of sync,
// e.g. a broad 2600–27BF block would also reject plain symbols like ★☆♪).
// Regional indicators (flag halves), ZWJ, variation selector (FE0F) and the
// keycap combining mark (20E3) aren't Extended_Pictographic but still form
// emoji sequences, so they're added on top. Written as explicit \u escapes
// rather than the literal (invisible) characters so they can't be
// accidentally deleted or mis-edited. Keep both patterns in sync if
// regenerated.
// ZWJ/FE0F/20E3 above are intentionally listed as individual codepoints to
// reject (not combined into a grapheme), matching the BE's
// codepoint-by-codepoint not_regex check.
export const NO_EMOJI_REGEX =
  // eslint-disable-next-line no-misleading-character-class
  /^[^©®‼⁉™ℹ↔-↙↩-↪⌚-⌛⌨⏏⏩-⏳⏸-⏺Ⓜ▪-▫▶◀◻-◾☀-☄☎☑☔-☕☘☝☠☢-☣☦☪☮-☯☸-☺♀♂♈-♓♟-♠♣♥-♦♨♻♾-♿⚒-⚗⚙⚛-⚜⚠-⚡⚧⚪-⚫⚰-⚱⚽-⚾⛄-⛅⛈⛎-⛏⛑⛓-⛔⛩-⛪⛰-⛵⛷-⛺⛽✂✅✈-✍✏✒✔✖✝✡✨✳-✴❄❇❌❎❓-❕❗❣-❤➕-➗➡➰➿⤴-⤵⬅-⬇⬛-⬜⭐⭕〰〽㊗㊙\u{1F000}-\u{1FFFD}\u{1F1E6}-\u{1F1FF}\u{200D}\u{FE0F}\u{20E3}]*$/u
